import styled from 'styled-components';

import { Clock } from '@r1-frontend/ui-react/components/svg/time';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const DefaultPromoStub = ({ className }: { className?: string }): JSX.Element => (
    <ListContainer $direction={'row'} $wrap={'nowrap'} $size={8} className={className}>
        <Clock size={24}/>
        <Paragraph4 $color={COLORS.TextInfo}>Предложения скоро появятся, а пока посмотрите, что у нас есть</Paragraph4>
    </ListContainer>
);

export default styled(DefaultPromoStub)`
    margin-top: 20px;
    margin-bottom: 60px;

    & > svg {
        #contour,
        #guts {
            stroke: ${COLORS.ButtonAccent};
        }
    }
`;
